var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 32.5C25.3366 32.5 32.5 25.3366 32.5 16.5C32.5 7.66344 25.3366 0.5 16.5 0.5C7.66344 0.5 0.5 7.66344 0.5 16.5C0.5 25.3366 7.66344 32.5 16.5 32.5Z",
    stroke: "#00703E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.145 19.3137V21.0169C22.1457 21.1751 22.1133 21.3316 22.0499 21.4765C21.9866 21.6213 21.8937 21.7514 21.7772 21.8583C21.6607 21.9652 21.5231 22.0466 21.3733 22.0972C21.2235 22.1479 21.0648 22.1667 20.9073 22.1525C19.1603 21.9626 17.4821 21.3656 16.0076 20.4095C14.6358 19.5378 13.4728 18.3747 12.6011 17.0029C11.6416 15.5218 11.0445 13.8354 10.8581 12.0805C10.8439 11.9235 10.8626 11.7653 10.9129 11.6159C10.9632 11.4665 11.0441 11.3292 11.1504 11.2128C11.2567 11.0964 11.386 11.0033 11.5302 10.9396C11.6744 10.8759 11.8303 10.843 11.988 10.8428H13.6912C13.9667 10.8401 14.2339 10.9377 14.4428 11.1174C14.6517 11.297 14.7881 11.5465 14.8267 11.8194C14.8986 12.3644 15.0319 12.8996 15.2241 13.4147C15.3005 13.618 15.3171 13.8388 15.2718 14.0511C15.2265 14.2634 15.1213 14.4583 14.9686 14.6127L14.2476 15.3337C15.0558 16.7551 16.2327 17.932 17.6541 18.7403L18.3752 18.0192C18.5295 17.8666 18.7244 17.7614 18.9367 17.7161C19.1491 17.6708 19.3699 17.6873 19.5731 17.7637C20.0882 17.9559 20.6234 18.0893 21.1685 18.1612C21.4443 18.2001 21.6962 18.339 21.8762 18.5515C22.0563 18.764 22.1519 19.0353 22.145 19.3137Z",
    fill: "#00703E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.26c2166bdb6b59fd022233bf9b32992b.svg";
export { ForwardRef as ReactComponent };